export function Marquee({ items }) {
  const row = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-imperium-champagne/50 py-6" aria-hidden="true" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="px-8 font-serif italic text-2xl md:text-3xl text-imperium-bronze whitespace-nowrap">{item}</span>
                <span className="h-1.5 w-1.5 rotate-45 bg-imperium-gold/70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
